// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/1.5.1/css/" + chunkId + "." + {"pages/MyReviewEdit":"adfd0c63","src_components_CustomDialog_DialogFooter_index_tsx-src_components_MediaExpandedView_index_tsx-17ca7a":"5176be02","pages/MyReviewPage":"d788325d","pages/PostReview":"ee0bdee5","pages/ProviderReview":"fe1b09c6"}[chunkId] + ".chunk.css";
};